import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import * as Sentry from '@sentry/angular';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

Sentry.init({
  enabled: environment.sentry.enabled,
  dsn: environment.sentry.dsn,
  release: environment.sentry.release,
  environment: environment.sentry.environment,
  tracePropagationTargets: environment.sentry.tracingOrigins,

  integrations: [Sentry.browserTracingIntegration()],

  sampleRate: environment.sentry.sampleRate,
  tracesSampleRate: environment.sentry.tracesSampleRate,
});

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => Sentry.captureException(err));
